import { Box } from '@apia/theme';
import { CollectorField } from '../CollectorField';
import { getLabelName, TLabel } from '@apia/util';

export class CollectorLabel extends CollectorField {
  private static maxId = 0;

  type = 'label';

  constructor(
    label: string | TLabel,
    private kind:
      | 'h1'
      | 'h2'
      | 'h3'
      | 'h4'
      | 'h5'
      | 'h6'
      | 'p'
      | 'label' = 'label',
  ) {
    super(`label${CollectorLabel.maxId++}`, label);
  }

  Component = () => {
    return <Box as={this.kind}>{getLabelName(this.label)}</Box>;
  };
}
